import React from "react";

const RangeSlider = ({
  min = 0,
  max = 100,
  value = 0,
  onChange,
  className = "",
  disabled = false,
  step = 1,
  ...props
}) => {
  const percentage = ((value - min) / (max - min)) * 100;

  const handleChange = (e) => {
    onChange?.(Number(e.target.value));
  };

  return (
    <input
      {...props}
      type="range"
      min={min}
      max={max}
      value={value}
      step={step}
      disabled={disabled}
      onChange={handleChange}
      className={className}
      style={{
        ...props.style,
        "--slider-progress": `${percentage}%`,
      }}
    />
  );
};

export default RangeSlider;